module.exports = "/images/lk.svg?7ef89b81368da6ccf54fbc759aef9ca3";